export default __webpack_public_path__ + "static/media/Camargue60s.55af3940.mp3";